const BREAKPOINTS = {
  "md-up": "(min-width: 768px)",
  "lg-up": "(min-width: 1024px)",
  "xxl-up": "(min-width: 1440px)",
  "xxxl-up": "(min-width: 1920px)",
};

window.isDesktop = () => window.matchMedia(BREAKPOINTS['lg-up']).matches;

// Set up breakpoint monitoring
Object.entries(BREAKPOINTS).forEach(([name, query]) => {
  const mediaQuery = window.matchMedia(query);

  mediaQuery.addEventListener("change", (e) => {
    window.dispatchEvent(
      new CustomEvent(`breakpoint-${name}`, {
        detail: { matches: e.matches, breakpoint: name },
      })
    );
  });
});
